import { render, staticRenderFns } from "./PosCashRegister.vue?vue&type=template&id=4937043f&scoped=true"
import script from "./PosCashRegister.vue?vue&type=script&lang=js"
export * from "./PosCashRegister.vue?vue&type=script&lang=js"
import style0 from "./PosCashRegister.vue?vue&type=style&index=0&id=4937043f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937043f",
  null
  
)

export default component.exports